import type { Components } from '@mildang/mui';
import type { Theme } from '@mildang/mui';

const createButtonGroup = ({ palette }: Theme): Components => ({
  MuiButtonGroup: {
    defaultProps: {
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        borderRadius: 8,
      },
      groupedContainedPrimary: {
        '&:not(:last-of-type)': {
          borderRightColor: palette.text.secondary,
        },
        '&.Mui-disabled:not(:last-of-type)': {
          borderRightColor: palette.text.secondary,
        },
      },
      groupedContainedSecondary: {
        '&:not(:last-of-type)': {
          borderRightColor: palette.secondary.strokeHover,
        },
        '&.Mui-disabled:not(:last-of-type)': {
          borderRightColor: palette.secondary.strokeHover,
        },
      },
      groupedOutlinedPrimary: {
        '&:hover': {
          borderColor: palette.stroke,
        },
      },
      groupedOutlinedSecondary: {
        '&:hover': {
          borderColor: palette.secondary.stroke,
        },
      },
      groupedTextPrimary: {
        '&:not(:last-of-type)': {
          borderRightColor: 'transparent',
        },
        '&:hover': {
          borderRightColor: 'transparent',
        },
      },
      groupedTextSecondary: {
        '&:not(:last-of-type)': {
          borderRightColor: 'transparent',
        },
        '&:hover': {
          borderRightColor: 'transparent',
        },
      },
    },
  },
});

export default createButtonGroup;
